import classNames from 'classnames';
import React, { ReactNode } from 'react';

export interface ReportingCardProps {
  title?: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
  noPadding?: boolean;
  actions?: ReactNode;
}

export const ReportingCard: React.FC<ReportingCardProps> = ({
  title,
  subtitle,
  children,
  className,
  noPadding = false,
  actions,
}) => {
  const hasHeader = !!title || !!subtitle || !!actions;

  return (
    <div
        className={classNames(
          'bg-white rounded-xl shadow-sm border border-gray-100 transition-shadow duration-150 ease-in-out hover:shadow-md',
          className,
        )}
    >
      { hasHeader && (
        <div className='flex items-start justify-between gap-3 border-b border-gray-50 px-5 py-4'>
          <div className='min-w-0'>
            { title && (
              <h3 className='text-sm font-semibold text-gray-700 uppercase tracking-wider'>
                { title }
              </h3>
            ) }
            { subtitle && (
              <p className='mt-0.5 text-xs text-gray-400'>{ subtitle }</p>
            ) }
          </div>
          { actions && <div className='flex-shrink-0'>{ actions }</div> }
        </div>
      ) }
      <div className={noPadding ? '' : 'p-5'}>
        { children }
      </div>
    </div>
  );
};
